export enum ErrorDevice {
  IphoneSafari = "IphoneSafari",
  WinChrome = "WinChrome",
  WinEdge = "WinEdge",
  MacChrome = "MacChrome",
  AndroidChrome = "AndroidChrome",
  IpadSafari = "IpadSafari",
}
